import { createApp, h } from 'vue';
import router from '../router' 
import ElementPlus from 'element-plus';
import twUI from 'tw-ui';

// 窗口服务，用于打开新窗口、对话框
const windowService = function() {

    var pub = {
        // 返回首页
        async goHome() {
            return router.push({ name: 'main' })
        },
        // 跳转
        go(delta) {
            router.go(delta)
        },
        // 打开页面
        async openPage(name, params, query) {
            return router.push({ name, params, query })
        },
        // 显示对话框
        async showDialog(name, params) {
            // 传文件名时认为是在 @/components 目录下，否则请使用传 module 的方式（通过 require 加载文件）
            // 如：const module = require('../components/common/query-dialog')
            let module
            if (name.default) {
                module = name
            } else {
                // module = await import(filePath)
                module = require(`@/components/${name}`)
            }
            return new Promise((resolve, reject) => {
                let app
                const formElement = document.createElement('div')
                const bodyElement = document.getElementsByTagName('body')[0]
                bodyElement.appendChild(formElement)
                new Promise((subResolve, subReject) => {
                    // 创建
                    app = createApp({
                        render() {
                            return h(module.default, {
                                params: params,
                                resolve: subResolve,
                                reject: subReject
                            });
                        }
                    })
                    // 容器挂载
                    app.use(ElementPlus).use(twUI).mount(formElement);
                }).then(data => {
                    setTimeout(() => {
                        app?.unmount()
                        bodyElement.removeChild(formElement)    
                    }, 500);
                    
                    resolve(data)
                }).catch(err => {
                    setTimeout(() => {
                        app?.unmount()
                        bodyElement.removeChild(formElement)    
                    }, 500);

                    reject(err)
                })
            })
        }
    }

    return pub;
}

var service = windowService();

export default service;